import { gql } from '@apollo/client';


export const DELIVERY_LOCATION_FRAGMENT = gql`
    fragment deliveryLocationFragment on delivery {
        id
        fullAddress {
            id
            city
            country_subdivision
        }
    }
`;
